module.exports = __webpack_public_path__ + "img/our_services_1.790e49d7.jpg";